(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[38784,69655,52892],{

/***/ 16705:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page-builder/[[...slug]]",
      function () {
        return __webpack_require__(67355);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/page-builder/wrapper.tsx + 1 modules
var wrapper = __webpack_require__(80694);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/page-builder/section/index.tsx + 3 modules
var page_builder_section = __webpack_require__(44984);
// EXTERNAL MODULE: ./src/page-builder/utils.ts
var utils = __webpack_require__(79961);
// EXTERNAL MODULE: ./src/components/svg/closeIcon.tsx
var closeIcon = __webpack_require__(69655);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/hooks/useStickyElement.ts
var useStickyElement = __webpack_require__(50522);
;// CONCATENATED MODULE: ./src/page-builder/page.tsx







const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    },
    ssr: false
});



const allowedPageToShowLegalNotice = [
    "[category]",
    "[generic-route]",
    "[keyword]", 
];
function Page() {
    const { routeConfig , category , domain , locale , domainNameTranslation , visitDetails , headerOffer , referrer , userAgent ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const { 1: forceUpdate  } = (0,react.useState)(0);
    const allowedPage = routeConfig?.replacedPortions?.find((page)=>allowedPageToShowLegalNotice.includes(page.key));
    let phoneNumber;
    if (category && headerOffer?.length) {
        phoneNumber = (0,sharedUtils/* getPhoneNumber */.ly)(headerOffer[0]);
    } else {
        phoneNumber = "";
    }
    const { 0: showModal , 1: setShowPartnerPopup  } = (0,react.useState)(false);
    const { 0: showLegalNotice , 1: setShowLegalNotice  } = (0,react.useState)(false);
    // Resolve whether to render all sections immediately (page overrides domain).
    // Default false preserves the deferred, hero-first rendering behavior.
    const renderSectionsImmediately = Boolean(routeConfig?.config?.settings?.renderAllSectionsImmediately ?? domain?.config?.renderAllSectionsImmediately ?? false);
    const { 0: renderAllSections , 1: setRenderAllSections  } = (0,react.useState)(renderSectionsImmediately);
    // Collect all component CSS once (memoized to prevent recalculation)
    // Must be called before early return to follow Rules of Hooks
    const allComponentCSS = (0,react.useMemo)(()=>{
        const sections = routeConfig?.config?.sections || [];
        return sections.flatMap((section, sectionIndex)=>section.components.map((component, componentIndex)=>{
                // Preserve original componentIndex to match rendering
                if (!component.css) return null;
                return (0,utils/* modifyCSSForElement */.Z2)(component.css, `#${component.id}-${componentIndex}-${sectionIndex}`);
            }).filter(Boolean)).join("\n");
    }, [
        routeConfig?.config?.sections
    ]);
    (0,react.useEffect)(()=>{
        if (!showModal) return;
        // Check if script already exists
        const existingScript = document.querySelector('script[src="https://dwy9ix7d387oz.cloudfront.net/scripts/embed.js"]');
        if (!existingScript) {
            const script = document.createElement("script");
            script.src = "https://dwy9ix7d387oz.cloudfront.net/scripts/embed.js";
            script.setAttribute("data-container", "participants-container");
            script.onload = ()=>{
                // Force re-render after script loads
                setTimeout(()=>forceUpdate((n)=>n + 1), 100);
            };
            document.body.appendChild(script);
            window.ParticipantsDB?.load("participants-container");
        } else {
            // Script already loaded, just force re-render
            window.ParticipantsDB?.load("participants-container");
            forceUpdate((n)=>n + 1);
        }
    }, [
        showModal
    ]);
    (0,react.useEffect)(()=>{
        setShowLegalNotice(category?.slug === "auto-accident" && !domain.config?.hideLegalNotice && (allowedPage || routeConfig?.config?.settings?.showLegalNotice || window.location.pathname === "/" || window.location.pathname === `/${locale}` || window.location.pathname.includes("free-consultation") || window.location.pathname.includes("/yt") || window.location.pathname.includes("claims")));
        // Defer non-hero sections to allow the hero to paint first
        const scheduleRenderSections = ()=>{
            if (typeof window.requestIdleCallback === "function") {
                window.requestIdleCallback(()=>setRenderAllSections(true), {
                    timeout: 1200
                });
            } else {
                // Fallback for older browsers
                setTimeout(()=>setRenderAllSections(true), 0);
            }
        };
        // When configured to render immediately, skip the deferral entirely.
        if (renderSectionsImmediately) {
            return;
        }
        // Give the browser a moment (next frame) before scheduling the rest
        const rafId = requestAnimationFrame(scheduleRenderSections);
        return ()=>{
            cancelAnimationFrame(rafId);
        };
    }, []);
    const stickySectionRef = (0,react.useRef)(null);
    const stickySectionWrapperRef = (0,react.useRef)(null);
    const nonStickySectionsRef = (0,react.useRef)(null);
    const { 0: isDesktopViewport , 1: setIsDesktopViewport  } = (0,react.useState)(false);
    // Update desktop state so sticky layout is only used at min-width 1024px.
    (0,react.useEffect)(()=>{
        const mediaQuery = window.matchMedia("(min-width: 1024px)");
        const updateViewportState = ()=>{
            setIsDesktopViewport(mediaQuery.matches);
        };
        updateViewportState();
        mediaQuery.addEventListener("change", updateViewportState);
        return ()=>{
            mediaQuery.removeEventListener("change", updateViewportState);
        };
    }, []);
    const sectionsForSticky = routeConfig?.config?.sections ?? [];
    const stickySectionOriginalIndexForSticky = sectionsForSticky.findIndex((sec, indx)=>sec.props?.isSticky && indx !== 0);
    const stickySectionEnabledForSticky = stickySectionOriginalIndexForSticky !== -1;
    const useStickyLayoutForSticky = stickySectionEnabledForSticky && isDesktopViewport;
    (0,useStickyElement/* useStickyElement */.A)(stickySectionRef, {
        getBoundary: ()=>nonStickySectionsRef.current,
        wrapperRef: stickySectionWrapperRef,
        enabled: useStickyLayoutForSticky,
        minWidth: 0
    });
    if (!routeConfig || !routeConfig.config?.sections) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    const storedReferrer =  true ? sessionStorage.getItem("page_referrer") : 0;
    const sections = routeConfig.config.sections;
    const heroSection = sections[0];
    const otherSections = sections.slice(1);
    // Sticky behavior:
    // - At most one section can be sticky.
    // - The hero section (index 0) is never allowed to be sticky, even when its isSticky prop is set to true.
    // - When present, on desktop viewport, the sticky section is rendered on the right side of the non-sticky sections and stays visible while scrolling within that area.
    //   On smaller viewports, the sticky section is rendered to be fixed to the bottom of the page
    const stickySectionOriginalIndex = sections.findIndex((sec, indx)=>sec.props?.isSticky && indx !== 0);
    const stickySectionEnabled = stickySectionOriginalIndex !== -1;
    const useStickyDesktop = stickySectionEnabled && isDesktopViewport; // for desktop viewports only
    const stickySection = stickySectionEnabled ? sections[stickySectionOriginalIndex] : undefined;
    const nonStickySections = sections.map((sec, indx)=>({
            section: sec,
            originalIndex: indx
        })).filter(({ section , originalIndex  })=>!section.props?.isSticky && originalIndex !== 0);
    const legalNoticeText = visitDetails.stateCode === "CA" ? domain?.translations?.[`${domainNameTranslation}_showLegalNoticeInsideCalifornia`] ?? "Advertising is paid for by attorneys participating in a joint advertising program, including Kevin Danesh, who are licensed to practice law only in California. A complete list of the attorneys participating in the program can be found ${sponsorsModal}. You may request an attorney by name. We are not a law firm or a lawyer referral service. This advertisement is not legal advice and does not guarantee or predict the outcome of your legal matter. Every case is different. Results depend on the laws, facts, and unique circumstances of each case. Hiring an attorney is an important decision that should not be based solely on advertising. Request free information about your attorney's background and experience. This advertisement does not imply greater quality in legal services than those provided by other attorneys. This advertisement does not imply that the attorneys are certified specialists or experts in any area of law. No legal services will be provided unless there is a signed agreement between the client and the attorney. We use cookies to personalize content and analyze website traffic. We also share information about your use of the site with our analytics partners, who may combine it with other data that you have provided or that they have collected through their services. By continuing to use this website, you agree to the use of cookies." : domain?.translations?.[`${domainNameTranslation}_showLegalNoticeOutsideCalifornia`] ?? "Advertising announcements are paid for by attorneys participating in a joint advertising program who are licensed to practice law in their respective states. You can find a complete list of the attorneys participating in the joint program ${sponsorsModal}. You may request an attorney by name. We are not a law firm or a lawyer referral service. This advertisement is not legal advice and is not a guarantee or prediction of the outcome of your legal matter. Every case is different. Results depend on the laws, facts, and unique circumstances of each case. Hiring an attorney is an important decision that should not be based solely on advertising. Request free information about your attorney's background and experience. This advertisement does not imply greater quality in legal services than those provided by other attorneys. This advertisement does not imply that the attorneys are certified specialists or experts in any area of law. No legal services will be provided unless there is a signed agreement between the client and the attorney. We use cookies to personalize content and analyze website traffic. We also share information about your use of the site with our analytics partners, who may combine it with other data that you have provided or that they have collected through their services. By continuing to use this website, you agree to the use of cookies.";
    const processLegalNoticeText = (text)=>{
        const placeholder = "${sponsorsModal}";
        const parts = text.split(placeholder);
        if (parts.length === 1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: text
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                parts[0],
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "text-[blue] cursor-pointer",
                    children: [
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            id: "modal-trigger",
                            className: "color:#3498db; text-[#3498db]",
                            onClick: ()=>{
                                setShowPartnerPopup(true);
                            },
                            children: domain?.translations?.[`${domainNameTranslation}_showLegalNoticeHereWord`] ?? "here"
                        })
                    ]
                }),
                parts[1]
            ]
        });
    };
    const rulesVariablesMapping = {
        phoneNumber: phoneNumber,
        referral: referrer || storedReferrer,
        visit: visitDetails,
        visitor: userAgent
    };
    const checkSectionRules = (mode, rules)=>{
        // No rules means don't hide the section
        if (!rules.length) return false;
        const isEmpty = (value)=>value === undefined || value === null || value === "";
        const parseCommaSeparated = (value)=>value.split(",").map((v)=>v.trim());
        const evaluateRule = (ruleOption)=>{
            let ruleValue = rulesVariablesMapping[ruleOption.rule];
            // Extract nested property if codeName is specified
            if (ruleOption.codeName && ruleValue && typeof ruleValue === "object") {
                ruleValue = ruleValue[ruleOption.codeName];
            }
            const { operator , value  } = ruleOption;
            switch(operator){
                case "equal":
                    return ruleValue === value;
                case "notEqual":
                    return ruleValue !== value;
                case "notExist":
                    return isEmpty(ruleValue);
                case "exist":
                    return !isEmpty(ruleValue);
                case "includes":
                    if (typeof ruleValue === "string") return ruleValue.includes(value);
                    if (Array.isArray(ruleValue)) return ruleValue.includes(value);
                    return false;
                case "notIncludes":
                    if (typeof ruleValue === "string") return !ruleValue.includes(value);
                    if (Array.isArray(ruleValue)) return !ruleValue.includes(value);
                    return true; // If not string/array, treat as "not included"
                case "containsOne":
                    if (typeof ruleValue !== "string") return false;
                    return parseCommaSeparated(value).some((item)=>ruleValue.includes(item));
                case "containsAll":
                    if (typeof ruleValue !== "string") return false;
                    return parseCommaSeparated(value).every((item)=>ruleValue.includes(item));
                case "notOneOf":
                    if (typeof ruleValue !== "string") return true;
                    return parseCommaSeparated(value).every((item)=>!ruleValue.includes(item));
                default:
                    return false;
            }
        };
        // OR between groups, AND within each group
        const rulesMatch = rules.some((group)=>group.every(evaluateRule));
        // "show" mode: hide section if rules DON'T match
        // "hide" mode: hide section if rules DO match
        return mode === "show" ? !rulesMatch : rulesMatch;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            allComponentCSS && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                    dangerouslySetInnerHTML: {
                        __html: allComponentCSS
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(page_builder_section/* default */.Z, {
                        variables: heroSection.variables ?? {},
                        components: heroSection.components,
                        props: heroSection.props,
                        sectionIndex: 0,
                        classIdentifier: heroSection.classIdentifier
                    }, 0),
                    stickySectionEnabled ? useStickyDesktop ? // ≥1024px – side-by-side: non-sticky left, sticky right
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sticky-wrapper flex flex-row items-start gap-[30px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: nonStickySectionsRef,
                                className: "nonStickySections min-w-0 flex-1",
                                children: nonStickySections && nonStickySections.map(({ section , originalIndex  })=>{
                                    if (section.props && section.props?.displaySectionRules && checkSectionRules(section.props.displaySectionRules.mode, section.props.displaySectionRules.rules)) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(page_builder_section/* default */.Z, {
                                        variables: section.variables ?? {},
                                        components: section.components,
                                        props: section.props,
                                        sectionIndex: originalIndex,
                                        classIdentifier: `otherSection ${section.classIdentifier ?? ""}`
                                    }, originalIndex);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: stickySectionWrapperRef,
                                className: "stickySectionWrapper flex-none shrink-0 min-w-[350px]",
                                children: stickySection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: stickySectionRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(page_builder_section/* default */.Z, {
                                        variables: stickySection.variables ?? {},
                                        components: stickySection.components,
                                        props: stickySection.props,
                                        sectionIndex: stickySectionOriginalIndex,
                                        classIdentifier: `stickySection ${stickySection.classIdentifier ?? ""}`
                                    }, stickySectionOriginalIndex)
                                })
                            })
                        ]
                    }) : // <1024px – sticky section fixed to the bottom of the page, non-sticky sections scroll normally
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: nonStickySectionsRef,
                        className: "relative w-full",
                        children: [
                            stickySection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: stickySectionWrapperRef,
                                className: "fixed bottom-0 left-0 right-0 z-50 w-full",
                                style: {
                                    height: "fit-content",
                                    maxHeight: "fit-content"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: stickySectionRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(page_builder_section/* default */.Z, {
                                        variables: stickySection.variables ?? {},
                                        components: stickySection.components,
                                        props: stickySection.props,
                                        sectionIndex: stickySectionOriginalIndex,
                                        classIdentifier: `stickySection ${stickySection.classIdentifier ?? ""}`
                                    }, stickySectionOriginalIndex)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full nonStickySections",
                                children: renderAllSections && nonStickySections.map(({ section , originalIndex  })=>{
                                    if (section.props && section.props?.displaySectionRules && checkSectionRules(section.props.displaySectionRules.mode, section.props.displaySectionRules.rules)) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(page_builder_section/* default */.Z, {
                                        variables: section.variables ?? {},
                                        components: section.components,
                                        props: section.props,
                                        sectionIndex: originalIndex,
                                        classIdentifier: `otherSection ${section.classIdentifier ?? ""}`
                                    }, originalIndex);
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: renderAllSections && otherSections.map((section, index)=>{
                            if (section.props && section.props?.displaySectionRules && checkSectionRules(section.props.displaySectionRules.mode, section.props.displaySectionRules.rules)) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(page_builder_section/* default */.Z, {
                                variables: section.variables ?? {},
                                components: section.components,
                                props: section.props,
                                sectionIndex: index + 1,
                                classIdentifier: `otherSection ${section.classIdentifier ?? ""}`
                            }, index + 1);
                        })
                    }),
                    showLegalNotice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "mb-[5rem]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    id: "legal-notice",
                                    className: "text-center text-xs text-gray-400",
                                    children: processLegalNoticeText(legalNoticeText)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                                onClose: ()=>{
                                    setShowPartnerPopup(false);
                                },
                                active: showModal,
                                closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(closeIcon["default"], {}),
                                backdropClosable: true,
                                modalStyles: {
                                    display: "flex",
                                    flexDirection: "column",
                                    maxHeight: "100%"
                                },
                                modalClassName: "h-[90vh] rounded",
                                bodyStyles: {
                                    overflowY: "scroll"
                                },
                                width: 900,
                                header: domain?.translations?.[`${domainNameTranslation}_showLegalNoticeSponsorsWord`] ?? "Sponsors",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pb-5 lg:px-9 px-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-col",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "participants-container"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/page-builder/[[...slug]].tsx




var __N_SSP = true;
function Index() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(wrapper/* default */.ZP, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {})
    });
}


/***/ }),

/***/ 69655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CloseIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CloseIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "47",
        height: "47",
        fill: "none",
        viewBox: "0 0 47 47",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M45.359 5.447A3.252 3.252 0 0045.35.85l.106.106a3.256 3.256 0 00-4.597-.009L23.865 17.941a1.003 1.003 0 01-1.424 0L5.447.947A3.252 3.252 0 00.85.956L.956.85a3.256 3.256 0 00-.009 4.597l16.994 16.994a1.003 1.003 0 010 1.424L.947 40.859a3.252 3.252 0 00.009 4.597L.85 45.35a3.256 3.256 0 004.597.009l16.994-16.994a1.003 1.003 0 011.424 0l16.994 16.994a3.252 3.252 0 004.597-.009l-.106.106a3.256 3.256 0 00.009-4.597L28.365 23.865a1.003 1.003 0 010-1.424L45.359 5.447z"
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [66699,80694,67127,49774,92888,40179], function() { return __webpack_exec__(16705); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);